import { combineReducers } from 'redux'
import reducer from './reducer'
import reducerLoadImages from './reducerLoadImages'

export default combineReducers({ reducer, loadImages: reducerLoadImages })
